var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletFloat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 7.91998V13.07C19.3 16.15 17.54 17.47 14.9 17.47H6.10999C5.65999 17.47 5.22999 17.43 4.82999 17.34C4.57999 17.3 4.34 17.23 4.12 17.15C2.62 16.59 1.70999 15.29 1.70999 13.07V7.91998C1.70999 4.83998 3.46999 3.52002 6.10999 3.52002H14.9C17.14 3.52002 18.75 4.47001 19.18 6.64001C19.25 7.04001 19.3 7.44998 19.3 7.91998Z",
    stroke: "#863DE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3011 10.9201V16.0701C22.3011 19.1501 20.5411 20.4701 17.9011 20.4701H9.11108C8.37108 20.4701 7.70109 20.3701 7.12109 20.1501C5.93109 19.7101 5.12109 18.8001 4.83109 17.3401C5.23109 17.4301 5.66108 17.4701 6.11108 17.4701H14.9011C17.5411 17.4701 19.3011 16.1501 19.3011 13.0701V7.9201C19.3011 7.4501 19.2611 7.03014 19.1811 6.64014C21.0811 7.04014 22.3011 8.38011 22.3011 10.9201Z",
    stroke: "#863DE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4984 13.1399C11.9565 13.1399 13.1385 11.9579 13.1385 10.4999C13.1385 9.04185 11.9565 7.85986 10.4984 7.85986C9.04041 7.85986 7.85843 9.04185 7.85843 10.4999C7.85843 11.9579 9.04041 13.1399 10.4984 13.1399Z",
    stroke: "#863DE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78 8.2998V12.6998",
    stroke: "#863DE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2217 8.30029V12.7003",
    stroke: "#863DE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletFloat);
export default __webpack_public_path__ + "static/media/wallet-float.3b261e850b42448616f21590e45c2103.svg";
export { ForwardRef as ReactComponent };